<template>
  <div class="body">
    <div class="index">
      <van-button class="enter1" plain hairline type="primary" @click="enter(1)">“乐享新车”申报入口</van-button>
      <van-button class="enter2" plain hairline type="primary" @click="enter(2)">滨海新区汽车展申报入口</van-button>
      <van-button class="enter2" plain hairline type="primary" @click="enter(3)">滨海新区购车补贴管理系统</van-button>
    </div>
    <!-- <img v-else style="width: 100%;" src="http://img.shaoxing.com.cn/a/10001/202402/1051c650e4821671e678b04f93d2a5e6.jpeg" alt=""> -->
  </div>
</template>
<script>
// import Vconsole from 'vconsole/dist/vconsole.min.js'
// let vConsole = new Vconsole()

import axios from 'axios'
import { util,mc } from '../../assets/common2.js'
// import { Loading } from 'vant'
export default {
  name: 'CarIndex',
  props: {
  },
  data () {
    return {
      auth: false,
      loading: true
    }
  },
  components: {

  },
  computed: {
  },
  created: function () {
    if (util.inWechat()&&!this.$route.query.iframe) {
      location.replace('http://m.shaoxing.com.cn/wakeup?url='+encodeURIComponent(location.href.split('#')[0]+'?iframe=1'))
    }
    // console.log(vConsole);
    // this.authHandle()
  },
  mounted: function () {
    
  },
  methods: {
    newForm() {
      this.refresh = false
      this.$router.push('/car/form/0')
    },
    authHandle() {
      util.Arequest((data) => {
        axios.post(`/encrypt3/form/auth?userid=${data.userid}&fid=${this.fid}`,{token:data.token}).then(res => {
            if (res.data.msg == 'ok') {
              this.auth = true
              this.$merchant = res.data.merchant
              this.loading = false
            } else if (res.data.msg == 'not allow') {
              this.auth = false
              this.loading = false
              // this.$toast('无权限')
            } else {
              this.$toast('网络繁忙\n稍后再进')
            }
          }).catch(() => {
            this.$toast('网络繁忙\n稍后再进')
          })
      })
    },
    enter(fid) {
      if (!mc.isClient()) {
        this.$toast('请在越牛新闻客户端查看')
      } else {
        this.$router.push('/car/'+fid)
      }
      
    }
  },
  watch: {

  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* .main {
  margin-top: 56.3vw;
} */

</style>
<style>
html,body {
  height: 100%
}
.body {
  background-color: aliceblue;
}
.index {
  margin: auto;
  width: 70%;
  height: 100vh;
}
.enter1 {
  margin-top: 60%;
  width: 100%;
}
.enter2 {
  margin-top: 2rem;
  width: 100%;
}
</style>
